import { DialogActions, DialogContent } from '@material-ui/core';
import React from 'react';
import { useMutation } from '@tanstack/react-query';
import { Alert } from '../common/Alert';
import { Button } from '../common/Button';
import { DialogTitle } from '../common/Dialog';
import { CloseIconButton } from '../common/IconButton';
import { Typography } from '../common/Typography';

export interface ReplaceGalleryModalProps {
  onClose: () => void;
  onKeep: () => Promise<void>;
  onReplace: () => Promise<void>;
}

export const ReplaceGalleryModal: React.FC<ReplaceGalleryModalProps> = ({
  onClose,
  onKeep,
  onReplace,
}) => {
  const keep = useMutation(onKeep);
  const replace = useMutation(onReplace);
  const loading = keep.isLoading || replace.isLoading;
  const error = keep.isError || replace.isError;
  const handleKeep = () => keep.mutate();
  const handleReplace = () => replace.mutate();

  return (
    <>
      <DialogTitle>Replace Gallery?</DialogTitle>
      <DialogContent>
        <Typography>
          A gallery with this name already exists in the destination folder. Do you want to replace
          it?
        </Typography>
        <Alert
          severity={'error'}
          shown={error}
          text='Could not save gallery. Please try again later.'
        />
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={handleKeep} disabled={loading}>
          Keep Both
        </Button>
        <Button onClick={handleReplace} disabled={loading}>
          Replace
        </Button>
        <CloseIconButton onClick={onClose} disabled={loading} />
      </DialogActions>
    </>
  );
};
